import { format } from 'date-fns';

import { BackgroundSQR } from '@ui/uikit/components/icons/poly';

import { CellProps } from './types';

export const RaffleCell = ({ row }: CellProps) => {
  return (
    <div className="flex gap-4 max-md-msq:w-full max-md-msq:justify-between">
      <div className="flex items-center gap-2 text-caption-sm-strong-a">
        <div className="w-4 h-4 border-rounded flex items-center justify-center">
          <BackgroundSQR className="icon-xs" />
        </div>
        <span className="text-base-text-primary">{`Raffle #${String(row.roundId)}`}</span>
      </div>
      <div className="text-base-text-tertiary text-caption-sm-a">
        {format(row.closeTimestamp, 'dd MMM yyyy')}
      </div>
    </div>
  );
};
